export const HANDLE = /^[a-z][a-z0-9]*(?:-[a-z0-9]+)*$/;

export const HANDLE_SHORTEST = 2;
export const HANDLE_LONGEST = 32;

export function whatIsWrongWith(handle: string): string | null {
  if (handle.length === 0) return "Pick a handle.";
  if (handle.length < HANDLE_SHORTEST) return `At least ${HANDLE_SHORTEST} characters.`;
  if (handle.length > HANDLE_LONGEST) return `At most ${HANDLE_LONGEST} characters.`;
  if (/[A-Z]/.test(handle)) return "Lower case only.";
  if (!/^[a-z]/.test(handle)) return "Start with a letter.";
  if (/[^a-z0-9-]/.test(handle)) return "Letters, numbers and hyphens only.";
  if (!HANDLE.test(handle)) return "Hyphens go between characters, one at a time.";
  return null;
}

export function whatIsWrongSoFar(handle: string): string | null {
  if (handle.length === 0) return null;
  if (/[A-Z]/.test(handle)) return "Lower case only.";
  if (!/^[a-z]/.test(handle)) return "Start with a letter.";
  if (/[^a-z0-9-]/.test(handle)) return "Letters, numbers and hyphens only.";
  if (/--/.test(handle)) return "Hyphens go between characters, one at a time.";
  if (handle.length > HANDLE_LONGEST) return `At most ${HANDLE_LONGEST} characters.`;
  return null;
}

export function isAHandle(handle: string): boolean {
  return whatIsWrongWith(handle) === null;
}
